<template>
  <div class="menu-list-header">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

.menu-list-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px 9px;
  border-bottom: 1px solid colors.$border-light;
}
</style>
